import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Users, Zap, Target, Trophy, RefreshCw } from "lucide-react";
import { CARD, OUTLINE_BTN } from "./adminStyles";

const OVERVIEW = [
  { key: "totalUsers", label: "Total Users", hint: "Registered accounts", icon: Users },
  { key: "activeUsers", label: "Active Users", hint: "Last 7 days", icon: Zap },
  { key: "totalActions", label: "Total Actions", hint: "Hunt, Farm, Advisor", icon: Target },
  { key: "totalLeads", label: "Leads Generated", hint: "All time", icon: Trophy },
];

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : "N/A");

const Th = ({ children }) => <th className="text-left p-4 text-xs text-gray-400 font-medium">{children}</th>;

export const AdminMetricsTab = ({ metrics, users, onRefresh }) => (
  <div className="space-y-6" data-testid="admin-metrics-tab">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {OVERVIEW.map(({ key, label, hint, icon: Icon }) => (
        <Card key={key} className={`${CARD} p-4`} data-testid={`metric-card-${key}`}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-lg bg-ism-teal/20"><Icon className="h-5 w-5 text-ism-teal" /></div>
            <span className="text-sm text-gray-400">{label}</span>
          </div>
          <div className="text-2xl font-bold text-white">{metrics?.[key] || 0}</div>
          <div className="text-xs text-gray-500 mt-1">{hint}</div>
        </Card>
      ))}
    </div>

    <Card className={CARD}>
      <div className="p-4 border-b border-gray-800 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-white flex items-center gap-2">
          <Users className="h-5 w-5 text-ism-teal" /> User Registry ({users.length})
        </h3>
        <Button onClick={onRefresh} variant="outline" size="sm" className={OUTLINE_BTN} data-testid="refresh-metrics-btn">
          <RefreshCw className="h-4 w-4 mr-2" /> Refresh
        </Button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-black/30">
              {["User", "Company", "Registered", "Last Active", "Actions", "Revenue Goal"].map((c) => <Th key={c}>{c}</Th>)}
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.userId} className="border-t border-gray-800 hover:bg-white/5" data-testid={`registry-row-${user.userId}`}>
                <td className="p-4">
                  <div className="text-sm text-white font-medium">{user.username || "N/A"}</div>
                  <div className="text-xs text-gray-500">{user.email || "No email"}</div>
                </td>
                <td className="p-4 text-sm text-gray-300">{user.companyName || "Not set"}</td>
                <td className="p-4 text-sm text-gray-400">{fmtDate(user.createdAt)}</td>
                <td className="p-4 text-sm text-gray-400">{fmtDate(user.lastActive)}</td>
                <td className="p-4"><Badge className="bg-ism-teal/20 text-ism-teal border-0">{user.actionCount || 0} actions</Badge></td>
                <td className="p-4 text-sm text-ism-teal">${(user.revenueGoal || 0).toLocaleString()}</td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-gray-500">No users registered yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </Card>
  </div>
);
